import api from '@/api/bi'

const state = {
}

const actions = {
  getChartConfigList (context, params) {
    return api.getChartConfigList(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
